import { Button } from 'common/components/Button/Button'
import { ConfirmationModal } from 'common/components/Modals/ConfirmationModal'
import { useDelete } from 'common/hooks/useApi'
import { PrimeIcons } from 'primereact/api'
import { toast } from 'react-toastify'
import { validatorsApiPaths } from 'services/validators/validators.api'

interface IProps {
  id: string
  refetch: () => void
}
export const CommunityRemoveWikiButton = ({ id, refetch }: IProps) => {
  const { isMutating, trigger } = useDelete<undefined, string>(validatorsApiPaths.deleteWiki(id))
  const onSubmit = async () => {
    await trigger(undefined, {
      onSuccess: () => {
        refetch()
        toast.success('Wiki and comments successfully deleted')
      },
      onError: (err) => {
        console.log({ err })
        toast.error('Could not delete wiki')
      },
    })
  }
  return (
    <ConfirmationModal
      onSubmit={onSubmit}
      isLoading={isMutating}
      title="Are you sure you want to delete this wiki?"
      text="This action cannot be undone. The wiki and their comments will be deleted."
    >
      <Button isLoading={isMutating} iconOnly>
        {!isMutating && <i className={`pi ${PrimeIcons.TRASH}`} />}
      </Button>
    </ConfirmationModal>
  )
}
